import { render, staticRenderFns } from "./totalSales.vue?vue&type=template&id=6d7d3318"
import script from "./totalSales.vue?vue&type=script&lang=js"
export * from "./totalSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports